'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import FinderActionsDropdown from 'DesignFinderUI/components/actions/FinderActionsDropdown';
import FinderActionsList from 'DesignFinderUI/components/actions/FinderActionsList';
import withActionsModals from 'DesignFinderUI/components/modals/hoc/withActionsModals';
import withAssetActions from 'DesignFinderUI/hocs/withAssetActions';
import HR from 'UIComponents/elements/HR';
import withNewAssetActions from 'DesignFinderUI/components/actions/withNewAssetActions';
import { getFileTypeI18nKey } from 'DesignData/helpers/finderHelpers';
import { FilePropTypes } from 'DesignData/propTypes/finder';
import { compose } from 'redux';
/**
 * Component
 */

class SecondaryActionsDropdown extends PureComponent {
  constructor(...args) {
    super(...args);

    this.getI18nOptions = () => {
      const {
        i18nKey,
        i18nOptions,
        fileType
      } = this.props;
      return Object.assign({}, i18nOptions, {
        folderType: text(i18nKey('folderTypes.default')),
        fileType: fileType ? text(getFileTypeI18nKey(fileType), {
          count: 1
        }) : ''
      });
    };
  }

  render() {
    const _this$props = this.props,
          {
      assetActions,
      actionHandlers,
      i18nKey,
      permissions,
      NewAssetActionsList,
      NewAssetForm,
      use
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["assetActions", "actionHandlers", "i18nKey", "permissions", "NewAssetActionsList", "NewAssetForm", "use"]);

    const {
      secondaryActions
    } = assetActions;
    const actions = [secondaryActions];

    const renderedButtonText = /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "DesignFinderUI.actions.SecondaryActionsDropdown.buttonText"
      })
    });

    const renderedActionsList = /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(FinderActionsDropdown, {
        buttonText: renderedButtonText,
        disabled: !secondaryActions.length,
        children: /*#__PURE__*/_jsx(FinderActionsList, Object.assign({}, rest, {
          actions: actions,
          handlers: actionHandlers,
          i18nKey: i18nKey,
          i18nOptions: this.getI18nOptions,
          permissions: permissions,
          use: use
        }))
      })
    });

    if (use === 'contextmenu') {
      if (NewAssetForm) {
        return NewAssetForm;
      }

      if (NewAssetActionsList) {
        return /*#__PURE__*/_jsxs("div", {
          children: [NewAssetActionsList, /*#__PURE__*/_jsx(HR, {
            className: "m-y-0"
          }), renderedActionsList]
        });
      }
    }

    return renderedActionsList;
  }

}
/**
 * Statics
 */


SecondaryActionsDropdown.propTypes = {
  ActionsModals: PropTypes.node,
  children: PropTypes.node,
  permissions: PropTypes.object.isRequired,
  assetActions: PropTypes.object.isRequired,
  actionHandlers: PropTypes.object.isRequired,
  i18nOptions: PropTypes.object.isRequired,
  i18nKey: PropTypes.func.isRequired,
  use: FinderActionsList.propTypes.use,
  NewAssetActionsList: PropTypes.node,
  NewAssetForm: PropTypes.node,
  fileType: FilePropTypes.fileType
};
SecondaryActionsDropdown.defaultProps = {
  ActionsModals: null,
  NewAssetActionsList: null,
  NewAssetForm: null,
  use: FinderActionsList.defaultProps.use
};
/**
 * Export
 */

export default compose(withNewAssetActions, withActionsModals, withAssetActions)(SecondaryActionsDropdown);